/* ==========================================================================
   Optimize Minerals — choosing a multi-pack selects One time

   Picking 2 or 4 canisters switches the plan to One time. Subscribe is left
   fully available: this sets a default, it does not take the choice away, and a
   shopper who wants four canisters a month can still say so by clicking
   Subscribe afterwards.

   Why it is worth doing at all. A multi-pack and a subscription answer the same
   question - "how do I pay less per canister" - and a shopper who has just
   chosen to buy four at once has answered it. Leaving Subscribe selected
   underneath commits them to four canisters every thirty days, which is a much
   larger promise than the one they think they are making, and the brief was
   explicit that a four-pack is a standalone deal rather than a subscription
   tier.

   The one-shot rule is what keeps it from becoming a fight. It fires on a PACK
   change and nothing else, so once it has switched the plan the shopper can
   click Subscribe and it stays clicked - there is no rule watching the plan
   waiting to undo them. It only ever moves again if they change pack again.

   Going back to 1 canister deliberately does NOT restore Subscribe. By then the
   shopper has chosen One time explicitly or implicitly, and re-selecting a
   subscription for them would change what they are buying without being asked.
   ========================================================================== */

(function () {
  'use strict';

  /* Skio renders in a shadow root, so the one-time radio cannot be reached with
     an ordinary querySelector from the page. */
  function oneTimeInput() {
    var picker = document.querySelector('skio-plan-picker');
    var root = picker && (picker.renderRoot || picker.shadowRoot);
    if (!root) return null;
    var group = root.querySelector('.group-container--one-time');
    return group ? group.querySelector('input.group-input') : null;
  }

  function selectOneTime() {
    var input = oneTimeInput();
    if (!input || input.checked) return true;
    /* click() rather than checked = true: Skio's handler is what updates the
       selling_plan input the form submits, and setting the property fires no
       event, so the radio would look chosen while the cart still carried the
       subscription. */
    input.click();
    return true;
  }

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio || !radio.classList || !radio.classList.contains('op-pack__radio')) return;
    if (Number(radio.getAttribute('data-pack-size') || 1) <= 1) return;

    /* Skio may not have rendered yet on a very early interaction, and its own
       re-render can land between the click and our read. A couple of retries
       cost nothing - selectOneTime is a no-op once the radio is already on. */
    if (selectOneTime() && oneTimeInput()) return;
    setTimeout(selectOneTime, 60);
    setTimeout(selectOneTime, 300);
  });
})();
